import React from 'react';
import PropTypes from 'prop-types';
// Components
import HeroWithCard from './standard-hero';
import HeroNoCard from './hero-no-card';
import BrandHero from '../hero-brand';
import CampaignHero from '../hero-campaign';
import CustomHero from '../hero-custom';
import DonationHeroWithInputBox from '../donation-hero-with-input-box';
import DonationHeroWithButtons from '../donation-hero-with-buttons';

const Hero = ({ content }) => {
  if (!content || !content.internal) return null;
  const { type } = content.internal;

  if (type === 'ContentfulComponentStandardHero') {
    return <HeroWithCard content={content} marginBottom />;
  }

  if (type === 'ContentfulComponentHeroNoCard') {
    return <HeroNoCard content={content} />;
  }

  if (type === 'ContentfulComponentDonationHeroWithButtons') {
    return <DonationHeroWithButtons content={content} />;
  }

  if (type === 'ContentfulComponentDonationHeroWithInputBox') {
    return <DonationHeroWithInputBox content={content} />;
  }

  if (type === 'ContentfulComponentBrandHero') {
    return <BrandHero content={content} />;
  }

  if (type === 'ContentfulComponentCampaignHero') {
    return <CampaignHero content={content} />;
  }

  if (type === 'ContentfulComponentCustomHero') {
    return <CustomHero content={content} />;
  }

  return null;
};

Hero.propTypes = {
  content: PropTypes.object,
};

export default Hero;
